import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20entertainment%20photography%20with%20warm%20golden%20and%20amber%20lighting%2C%20soft%20cinematic%20bokeh%20background%2C%20artistic%20atmosphere%2C%20sophisticated%20and%20intimate%20mood%2C%20warm%20cream%20and%20terracotta%20tones%2C%20professional%20photography%20style%20with%20vintage%20elegance&width=1800&height=900&seq=yoshizawa-hero-bg&orientation=landscape"
          alt="吉泽明步粉丝资讯站"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium tracking-wide mb-6">
          吉泽明步 · 官方粉丝资讯站
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          吉泽明步
          <span className="block text-2xl md:text-3xl lg:text-4xl font-normal mt-3 text-background-50/85">
            官方资料 · 作品 · 完整介绍
          </span>
        </h1>
        <p className="text-sm md:text-base text-background-50/75 max-w-2xl mx-auto leading-relaxed mb-10">
          本页全面介绍吉泽明步的个人资料、演艺经历、代表作品及相关信息。无论你是初次了解还是深度粉丝，这里汇聚关于吉泽明步最权威、最详尽的内容，助你快速掌握全貌。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/personal"
            className="w-full sm:w-auto px-7 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
          >
            了解个人资料
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/works"
            className="w-full sm:w-auto px-7 py-3 bg-background-50/15 text-background-50 font-medium text-sm rounded-lg hover:bg-background-50/25 border border-background-50/20 transition-all duration-200 whitespace-nowrap"
          >
            浏览代表作品
          </Link>
        </div>
      </div>
    </section>
  );
}